import React from 'react';
import PropTypes from 'prop-types';

export default class Finish extends React.Component {
	static propTypes = {
		data: PropTypes.object,
		parent: PropTypes.object,
	};

	constructor( props ) { 
		super( props );

		this.state = { 
		};
	}

	render() {
		return ( <div className="signupprocess_container">
			<h2>All Done!</h2>

			<p>
					You have successfully registered for your account. Your next step is to verify your account 
					information by clicking on the link you recieved by email.  If you don&apos;t see the email, take a look 
					in your junk folder - sometimes it ends up in there.  If you cannot find your
					email, { this.props.data.email ? 
					<span>
						<a onClick={ () => { this.props.parent.resendVerify(); } } >you can resend it</a> or
					</span> : null } you can speak to your instructor - they have access to verify your account.
			</p>

			<p>
					When you verify your account and signup for a webspace, you will recieve a userid for the system.  You can see
					it on the admin bar at the top beside &quot;Webspace User&quot;.  This is the user you will use
					to access your Webspace if your instructor asks your to do something via FTP
			</p>

				
		</div>
		);
	}
}